import {
  ActivityType,
  ReportOptions,
  ReportTypes,
} from '@showbie-socrative/socrative-utils';

type SupportedReportOptionsWithDefaults = {
  [key in ReportOptions]?: boolean;
};

export type SupportedReportSettings = {
  [key in ReportTypes]?: SupportedReportOptionsWithDefaults;
};

export function getReportSettings(
  activityType: ActivityType
): SupportedReportSettings {
  switch (activityType) {
    case ActivityType.Quiz:
    case ActivityType.SpaceRace:
      return {
        [ReportTypes.IndividualStudentPDF]: {
          [ReportOptions.IncludeExplanations]: false,
          [ReportOptions.IncludeCorrectAnswers]: false,
        },
        [ReportTypes.EmptyQuiz]: {
          [ReportOptions.IncludeExplanations]: false,
          [ReportOptions.IncludeCorrectAnswers]: true,
        },
        [ReportTypes.WholeClassExcel]: {
          [ReportOptions.IncludeMultipleChoiceContent]: true,
        },
        [ReportTypes.QuestionSpecificPDF]: {
          [ReportOptions.IncludeExplanations]: false,
        },
      };
    case ActivityType.QuickQuestionShortAnswer:
      return {
        [ReportTypes.WholeClassExcel]: {
          [ReportOptions.IncludeMultipleChoiceContent]: true,
        },
        [ReportTypes.QuestionSpecificPDF]: {
          [ReportOptions.IncludeExplanations]: false,
        },
      };
    case ActivityType.Vote:
      return {
        [ReportTypes.WholeClassExcel]: {
          [ReportOptions.IncludeMultipleChoiceContent]: true,
        },
        [ReportTypes.QuestionSpecificPDF]: {
          [ReportOptions.IncludeExplanations]: false,
        },
      };
    case ActivityType.NoReport:
    default:
      return {};
  }
}
